import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { Opponent } from 'src/app/shared/models/data/opponent';
import { OpponentSearchResults } from 'src/app/shared/models/data/opponentSearchResults';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../error/error.service';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class OpponentsApiService extends ApiBaseService {

  baseUrl = environment.backend_host + '/api/opponents';

  constructor(
    public http: HttpClient,
    protected errorService: ErrorService,
    protected spinner: NgxSpinnerService) {
    super(spinner, errorService);
  }

  // all opponents
  public getOpponents = (params: SearchParams): Observable<OpponentSearchResults> => {
    const p = this.serializeParamsObj(params, new HttpParams());
    return this.http.get<any>(`${this.baseUrl}/`, { params: p })
      .pipe(map(this.deserializeAs(OpponentSearchResults)));
  }

  public getOpponent = (opp: Opponent): Observable<Opponent> => {
    return this.http.get<any>(`${this.baseUrl}/${opp.id}`)
      .pipe(map(this.deserializeAs(Opponent)));
  }

  public createOpponent = (opp: Opponent): Observable<Opponent> => {
    return this.http.post<any>(`${this.baseUrl}/`, this.serialize(opp))
      .pipe(map(this.deserializeAs(Opponent)));
  }

  public updateOpponent = (opp: Opponent): Observable<Opponent> => {
    return this.http.put<any>(`${this.baseUrl}/${opp.id}`, this.serialize(opp))
      .pipe(map(this.deserializeAs(Opponent)));
  }

  public deleteOpponent = (opp: Opponent): Observable<any> => {
    return this.http.delete<any>(`${this.baseUrl}/${opp.id}`)
      .pipe(share());
  }
}
